import {
  getLectures,
  getLecturesById
}
  from '~api/lectures'

export const state = () => ({
  lectures: [],
  pages: {},
  currentLecturesDetails: {}
})

export const getters = {
  lecturesGetter: state => state.lectures,
  pageGetter: state => state.pages,
  currentLecturesDetailsGetter: state => state.currentLecturesDetails
}

export const actions = {
  async getLecturesAll ({
    commit
  }, params) {
    const data = await getLectures(params)
    const {
      lectures,
      pages
    } = data

    commit('setLectures', lectures)
    commit('setLecturesPage', pages)

    return data
  },
  async getLecturesDetailsById ({
    commit
  }, id) {
    const lecture = await getLecturesById(id)
    commit('setCurrentLecturesDetails', lecture)
  }
}

export const mutations = {
  setLectures (state, payload) {
    state.lectures = payload
  },
  setLecturesPage (state, payload) {
    state.pages = payload
  },
  setCurrentLecturesDetails (state, payload) {
    state.currentLecturesDetails = payload
  }
}
